import Icon from '../components/Icon.vue'

Icon.register({
  'toilet-paper': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M128 0h284.4c-36.8 38.5-60.4 108.4-60.4 192v172.1c0 53.6-11.9 87.6-24.7 126-4.4 13.1-16.6 21.9-30.4 21.9h-280.9c-10.9 0-18.6-10.7-15.2-21.1 21.4-64.1 31.2-85.8 31.2-126.9v-172.1c0-106 43-192 96-192zM96 224c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM160 224c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM224 224c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM288 224c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM480 0c53 0 96 86 96 192s-43 192-96 192-96-86-96-192 43-192 96-192zM480 256c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toilet-paper.js
// module id = 2017
// module chunks = 0